import { Button } from "@ncoder/ui";
import { Badge } from "@ncoder/ui";

interface CategoryButtonProps {
  label: string;
  isActive: boolean;
  count?: number;
  onClick: () => void;
}

export const CategoryButton: React.FC<CategoryButtonProps> = ({
  label,
  isActive,
  count,
  onClick,
}) => (
  <Button
    variant={isActive ? "default" : "outline"}
    size="sm"
    className="whitespace-nowrap"
    onClick={onClick}
  >
    {label}
    {count && (
      <Badge variant="secondary" className="ml-2">
        {count}
      </Badge>
    )}
  </Button>
);
